import { useAuthContext } from 'src/hooks/auth/use-auth-context';

import { isAdmin } from 'src/services/auth/auth.utils';

/**
 * Whether the signed-in user may import records from a CSV: organisation admins and operational
 * admins, the rule the server enforces with IMPORT_RECORDS (JT1-1737).
 */
export function useCanImport(): boolean {
  const authContext = useAuthContext();

  return Boolean(authContext?.account) && isAdmin(authContext);
}
